import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import NewsletterForm from "./NewsletterForm";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#E2E8F0]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-14">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="SportScience Academy" className="w-10 h-10 object-contain" data-testid="footer-logo-image" />
              <span className="font-heading font-black text-lg text-[#0B1B3A]">
                SportScience<span className="text-[#1D4ED8] ml-1">Academy</span>
              </span>
            </div>
            <p className="font-heading font-black text-2xl md:text-3xl text-[#1E293B] mt-6 max-w-lg leading-tight">
              {t("brand.tagline")}
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <Link data-testid="footer-articles-link" to="/articles" className="text-sm font-semibold text-[#334155] hover:text-[#1D4ED8] transition-colors duration-200">
              {t("nav.articles")}
            </Link>
            <Link data-testid="footer-courses-link" to="/courses" className="text-sm font-semibold text-[#334155] hover:text-[#1D4ED8] transition-colors duration-200">
              {t("nav.courses")}
            </Link>
            <Link data-testid="footer-b2b-link" to="/b2b" className="text-sm font-semibold text-[#334155] hover:text-[#1D4ED8] transition-colors duration-200">
              {t("nav.b2b")}
            </Link>
            <Link data-testid="footer-register-link" to="/register" className="text-sm font-semibold text-[#334155] hover:text-[#1D4ED8] transition-colors duration-200">
              {t("nav.register")}
            </Link>
            <Link data-testid="footer-login-link" to="/login" className="text-sm font-semibold text-[#334155] hover:text-[#1D4ED8] transition-colors duration-200">
              {t("nav.login")}
            </Link>
          </div>
        </div>
        <div className="mt-12 pt-10 border-t border-[#E2E8F0]">
          <NewsletterForm />
        </div>
        <div className="mt-12 pt-6 border-t border-[#E2E8F0] flex flex-wrap items-center justify-between gap-3">
          <span className="text-xs text-[#94A3B8]">© 2026 SportScience Academy</span>
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#94A3B8]">{t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
};
